"use strict";

var authenticationServiceModule = angular.module('service.Authentication', []);

authenticationServiceModule.factory('authenticationService', ['$http', '$q', 'appSettings', 'storageKeys', 'localStorageService', 'userService', '$rootScope', 'filterFilter', 'storeService', '$log', function ($http, $q, appSettings, storageKeys, localStorageService, userService, $rootScope, filterFilter, storeService, $log) {

    function setApplicationUserContext(tokenResponse) {
        var claims = tokenResponse.profile;
        // enforce roles property to be an array because vegas works with that.
        // the role claim we receive can be either a single value or an array depending
        // if the user has multiple roles
        var roles = angular.isArray(claims.role) ? claims.role : claims.role.split(",");

        var localProfile = {
            username: claims.sub,
            firstName: claims.given_name,
            lastName: claims.family_name,
            roles: roles,
            serviceProvider: 0,
            isEngineer: isEngineer,
            isStoreUser: isStoreUser,
            isStoreApprover: isStoreApprover,
            isStoreManager: isStoreManager,
            isAdmin: isAdmin,
            casLogin : false
        };

        // if user has previously logged in with Cas
        if("idp" in claims && claims["idp"] === "Cas"){
            localProfile.casLogin = true
        }

        $log.debug("AuthService: Setting local profile", localProfile)
        localStorageService.set(storageKeys.profileKey, localProfile);
        return localProfile
    }

    // gets user profile constructed in etech api
    // sets the service provider id in profile if user has one
    function getUserProfileDetails(localProfile) {
        userService.profile()
            .then(function (resource) {
                if (resource.$has("engineer")) {
                    resource.$get("engineer").then(function (engineer) {
                        localProfile.engineer = engineer;
                        engineer.$get("serviceProvider").then(function (serviceProvider) {
                            localProfile.serviceProvider = serviceProvider.id;
                            localStorageService.set(storageKeys.profileKey, localProfile);
                            $log.debug("AuthService: Setting service provider to profile", serviceProvider)
                            $rootScope.$broadcast('event:serviceProviderFetched', localProfile);
                        });
                    });
                }
            })
            .catch(function (error) {
                $log.error("AuthService: While getting user profile details", error)
            })
    }

    // set login type according to the user role
    function setLoginType() {
        if (isEngineer()) {
            $log.debug("AuthService: Setting login type: ENGINEER ")
            storeService.removeStoreContext()
            localStorageService.set(storageKeys.loginTypeKey, 'ENGINEER');
        }
        else if (isStoreUser()) {
            $log.debug("AuthService: Setting login type: STORE")
            localStorageService.set(storageKeys.loginTypeKey, 'STORE');
        }else if(isAdmin()){
            $log.debug("AuthService: Setting login type: IMPERSONATE")
            localStorageService.set(storageKeys.loginTypeKey, 'IMPERSONATE');
        }
        else {
            localStorageService.remove(storageKeys.loginTypeKey)
            $log.error("AuthService: User does not have any roles")
        }
    }

    function setCustomStoreContextHeader() {
        var store = storeService.getStore()
        if (!store)
            return

        if ('X-Context-Store' in $http.defaults.headers.common) {
            $log.debug("AuthService: Custom header for store context already set")
        }
        else {
            $http.defaults.headers.common['X-Context-Store'] = store.storeAuthentication
            $log.debug("AuthService: Setting custom header for store context")
        }
    }

    function validateCustomStoreContextHeaderByStoreId() {
        if ('X-Context-Store' in $http.defaults.headers.common) {
            $log.debug("AuthService: Custom header for store context already set");
            return true;
        } else {
            var store = storeService.getStore()
            if (!store) {
                return false;
            } else {
                $http.defaults.headers.common['X-Context-Store'] = store.storeAuthentication;
                $log.debug("AuthService: Setting custom header for store context");
                return true;
            }
        }
    }

    function isEngineer() {
        return userHasRole('ENGINEER')
    }

    function isAdmin(){
        return userHasRole('HK_ADMIN')
    }

    function isStoreUser() {
        return isStoreApprover() || isStoreManager()
    }

    function isStoreApprover() {
        return userHasRole("STORE_APPROVER")
    }

    function isStoreManager() {
        return userHasRole("STORE_MANAGER")
    }

    function userHasRole(role) {
        var profile = localStorageService.get(storageKeys.profileKey);
        if (profile == null)
            return false;
        if (!angular.isArray(profile.roles)) {
            $log.error("AuthService: Roles is not an array.")
        }

        var found = filterFilter(profile.roles, role);
        return (found.length > 0);
    }

    function cleanLocalStorage() {
        if (!storeService.isStoreMode()) {
            storeService.removeStoreContext()
        }

        $log.debug("AuthService: Removing profile and auth data from local storage")
        localStorageService.remove(storageKeys.profileKey);
    }

    return {
        setCustomStoreContextHeader: setCustomStoreContextHeader,
        validateCustomStoreContextHeaderByStoreId: validateCustomStoreContextHeaderByStoreId,
        getUserProfileDetails: getUserProfileDetails,
        setApplicationUserContext: setApplicationUserContext,
        isEngineer: isEngineer,
        isStoreUser: isStoreUser,
        userHasRole: userHasRole,
        setLoginType: setLoginType,
        cleanLocalStorage: cleanLocalStorage,
        isAdmin: isAdmin
    };
}]);
